var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a6 6 0 0 1 6-6h32a6 6 0 0 1 6 6v19.429a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V18Z",
    fill: "#D7FFD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.19 23h-6.753c.393 2.23 2.557 4.328 4.918 4.328h5.377c.066-.197.066-.525.066-.721 0-1.968-1.64-3.607-3.607-3.607Z",
    fill: "#27B1E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.026 27.721v5.443h3.279v-2.885h2.885c1.574 0 2.951-1.115 3.41-2.558h-9.574ZM24.485 23v10.099h2.885s.721 0 1.115-.722c1.967-3.869 2.557-5.049 2.557-5.049h.394v5.77h3.279V23h-2.886s-.721.066-1.115.721c-1.64 3.345-2.557 5.05-2.557 5.05h-.394V23h-3.278ZM10.714 33.164V23.066h3.279s.918 0 1.443 1.442c1.311 3.804 1.442 4.328 1.442 4.328s.263-.918 1.443-4.328c.525-1.442 1.443-1.442 1.443-1.442h3.279v10.098h-3.28v-5.442h-.393l-1.836 5.442h-1.442l-1.837-5.442h-.393v5.442h-3.148Z",
    fill: "#4FAD50"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.43413e42.svg";
export { ForwardRef as ReactComponent };